import React, { Component,Suspense } from 'react';
import './App.scss';
import HomePage from './components/Address/HomePage';
import { HashRouter as Router,Route, Switch} from 'react-router-dom';
import Wait from '@react/react-spectrum/Wait';
import Footer from './components/Footer/Footer';
import ToastInfo from "./components/Common/ToastInfo";
import Header from './components/Header/Header';
import {loadConfig} from "./actions/AppActions";
import connect from "react-redux/es/connect/connect";

class App extends Component {
  render() {
      const divStyle = {
          minHeight: "calc(100vh - 120px)"
      };

      const Loader = () => (
          <div style={divStyle}>
              <Wait centered size="L"/>
          </div>
      );


      return (
        <Suspense fallback={<Loader />}>
            { (this.props.applicationConfig.name) ? (<Header />) :'' }
            <ToastInfo />
            {(this.props.isSignIn) ? (
                <div style={divStyle}>
                    <Router basename={process.env.PUBLIC_URL}>
                        <Switch>
                            <Route path="/" component={HomePage} />
                            
                        </Switch>
                    </Router>
                </div>
            ) :(<Loader />)}
           <Footer />
        </Suspense>
    );
  }

    componentDidMount(){
        this.props.loadConfig();
        
    }
}

const mapStateToProps = (state)=>{
    return{
        isSignIn:state.AuthReducer.isSignIn,
        applicationConfig : state.AppReducer.applicationConfig
    }
};


const mapDispatchToProps = (dispatch)=>{
    return{
        loadConfig:() => {dispatch(loadConfig())}
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(App);
